import { Link, useLocation } from 'react-router-dom';
import Layout from '@/components/feature/Layout';

export default function NotFound() {
  const location = useLocation();

  return (
    <Layout>
      <section className="relative w-full min-h-[80vh] flex items-center pt-28 pb-16 px-4 md:px-8 bg-background-50">
        <span className="absolute inset-x-0 top-1/3 text-center font-heading text-[7rem] md:text-[12rem] text-background-200 select-none pointer-events-none">
          404
        </span>
        <div className="relative z-10 max-w-xl mx-auto text-center">
          <span className="inline-flex w-16 h-16 rounded-full bg-primary-100 text-primary-700 items-center justify-center text-3xl">
            <i className="ri-map-pin-2-line"></i>
          </span>
          <h1 className="mt-5 text-2xl md:text-3xl text-foreground-950">这个页面走丢了</h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            你访问的地址
            <span className="mx-1 px-2 py-0.5 rounded bg-background-100 text-foreground-800 text-xs">{location.pathname}</span>
            暂时没有对应内容，可能是链接有误或者页面已经调整。
          </p>
          <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-home-4-line"></i>
              回到首页
            </Link>
            <Link
              to="/activities"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-background-100 text-foreground-800 text-sm font-medium whitespace-nowrap hover:bg-background-200 transition-colors cursor-pointer"
            >
              <i className="ri-gift-line"></i>
              去看福利活动
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}